module.exports = __webpack_public_path__ + "media/2.94e70ba4.mp3";